import axios from 'axios'
import { getCookie } from 'common/util/cookie'
axios.defaults.baseURL = process.env.REACT_APP_API_URL

const Api = {
    categoryDataAPI(idx_b_manager) {
        const url = `/front/v3/item/cate?idx_b_manager=${idx_b_manager}`
        return axios.post(url)
    },
    userInfo() {
        const url = '/front/v2/user/info'
        const auth_token = getCookie('auth_token')
        const config = {
            withCredentials: true,
            xsrfHeaderName: 'Authorization'
        }
        return axios.post(url, {auth_token}, config)
    },
    getItem:function(item_id, mall_id){
        let config = {
            withCredentials: true,
            xsrfHeaderName: 'Authorization'
        }
        let _url = "/front/v3/item/view/"+item_id;
        if (mall_id !== undefined && mall_id !== 1 && mall_id !== '') {
            _url += "/"+mall_id
        }
        return axios.get(_url, config);
    },
}

export default Api



// WEBPACK FOOTER //
// ./src/m_header/utils/api.js